import React, { useEffect } from "react";
import PublicLayout from "web/components/PublicLayout";

import IndustryCatchUp from "web/pages/public/landing-page/NewsRoom/IndustryCatchUp";
import SocialMediaCatchUp from "web/pages/public/landing-page/NewsRoom/SocialMediaCatchUp";
import LandingFooter from "web/pages/public/landing-page/LandingFooter";

const NewsRoom = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <PublicLayout transparentHeader={true}>
      <IndustryCatchUp />
      <SocialMediaCatchUp />
      <LandingFooter />
    </PublicLayout>
  );
};

export default NewsRoom;
